// ==============================|| THEME CONSTANT ||============================== //

export const APP_DEFAULT_PATH = '/dashboard/default';
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;

const config = {
  fontFamily: `'Public Sans', sans-serif`
};

// ──────────────────────────────────────────────────────────────────────
// 국양건축사사무소 30주년 이벤트 (2026-06-19 하루 한정)
//
//  - DATE(로컬)에만 모달이 뜨고, 자정이 지나면 코드 수정 없이 자동으로 사라진다.
//  - 로그인(대시보드 진입) 시 1회만 노출, 닫으면 "다시 보지 않기" 로 기억된다.
//  - 읽기 전용(사건 수 집계 1회) — 기존 데이터/화면/흐름은 전혀 건드리지 않는다.
//  - 문제가 생기면 ENABLED 를 false 로 두는 것만으로 즉시 비활성화된다.
// ──────────────────────────────────────────────────────────────────────
export const ANNIVERSARY = {
  ENABLED: true,
  DATE: '2026-06-19',
  YEARS: 30,
  OFFICE: '국양건축사사무소',
  MESSAGE: '30년 버틴 국양도 대단,\n 아빠는 더 대단😎,\n모두가 다 대단해요!!',
  STORAGE_KEY: 'kukyang-30th-dismissed',
  // 대시보드 진입 시 꽃가루 1회 버스트(CONFETTI_MS 후 멈춤). 다른 화면으로 나가도 멈춘다.
  // (클릭은 막지 않음 — pointer-events: none)
  CONFETTI: true,
  CONFETTI_MS: 8000
};

export default config;
